/*
 * *****************************************************************************
 * File: privacy.js (/src/pages/privacy.js) | frontend
 * Written by Andrea Corsini <andrea@rs1.it>
 * =============================================================
 * Created on Sunday, 14th March 2021 5:23:41 pm
 *
 * Copyright (c) 2020-2021 Andrea Corsini T/A RS1 Project - All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * Modified on Wednesday, 31st March 2021 4:32:11 pm
 * *****************************************************************************
 */
import React from 'react'
import { Helmet } from 'react-helmet'
import styled from '@emotion/styled'

const Page = () => (
    <>
        <Helmet>
            <title>Privacy Policy</title>
        </Helmet>
        <Heading>Privacy Policy</Heading>
        <Content>
            Questa App raccoglie alcuni Dati Personali dei propri Utenti.
            <br />
            <h3>Titolare del Trattamento dei Dati</h3>
            RS1 Project
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;<i>31 Mereworth Drive</i>
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;<i>SE18 3ED – London, UK</i>
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;
            <i>
                <b>Email:</b> info@veicolo.app
            </i>
            <br />
            <br />
            <h3>Tipologie di Dati raccolti</h3>
            Fra i Dati Personali raccolti da questa App, in modo autonomo o
            tramite terze parti, ci sono: accesso alla fotocamera; accesso agli
            account social media; cookie; dati di utilizzo; nome, cognome,
            email; password; identificatori univoci di dispositivi per la
            pubblicit&agrave; (Google Advertiser ID o identificatore IDFA, per
            esempio).
            <br />
            Dettagli completi su ciascuna tipologia di dati raccolti sono
            forniti nelle sezioni dedicate di questa privacy policy o mediante
            specifici testi informativi visualizzati prima della raccolta dei
            dati stessi.
            <br />
            I Dati Personali possono essere liberamente forniti dall&#39;Utente
            o, nel caso di dati di utilizzo, raccolti automaticamente durante
            l&#39;uso di questa App.
            <br />
            Se non diversamente specificato, tutti i Dati richiesti da questa
            App sono obbligatori. Se l&#39;Utente rifiuta di comunicarli,
            potrebbe essere impossibile per questa App fornire il Servizio. Nei
            casi in cui questa App indichi alcuni Dati come facoltativi, gli
            Utenti sono liberi di astenersi dal comunicare tali Dati, senza che
            ci&ograve; abbia alcuna conseguenza sulla disponibilit&agrave; del
            Servizio o sulla sua operativit&agrave;.
            <br />
            Gli Utenti che dovessero avere dubbi su quali Dati siano
            obbligatori, possono contattare il Titolare.
            <br />
            L&#39;eventuale utilizzo di Cookie - o di altri strumenti di
            tracciamento - da parte di questa App o dei titolari dei servizi
            terzi utilizzati da questa App, ove non diversamente precisato, ha
            la finalit&agrave; di fornire il Servizio richiesto dall&#39;Utente,
            oltre alle ulteriori finalit&agrave; descritte nel presente
            documento e nei Termini di Servizio.
            <br />
            L&#39;Utente si assume la responsabilit&agrave; dei Dati Personali
            di terzi ottenuti, pubblicati o condivisi mediante questa App e
            garantisce di avere il diritto di comunicarli o diffonderli,
            liberando il Titolare da qualsiasi responsabilit&agrave; verso
            terzi.
            <br />
            <br />
            <h3>Modalit&agrave; e luogo del trattamento dei Dati raccolti</h3>
            <h5>Modalit&agrave; di trattamento</h5>
            Il Titolare adotta le opportune misure di sicurezza volte ad
            impedire l&#39;accesso, la divulgazione, la modifica o la
            distruzione non autorizzate dei Dati Personali. <br />
            Il trattamento viene effettuato mediante strumenti informatici e/o
            telematici, con modalit&agrave; organizzative e con logiche
            strettamente correlate alle finalit&agrave; indicate. Oltre al
            Titolare, in alcuni casi, potrebbero avere accesso ai Dati altri
            soggetti coinvolti nell&#39;organizzazione di questa App (personale
            amministrativo, commerciale, marketing, legali, amministratori di
            sistema) ovvero soggetti esterni (come fornitori di servizi tecnici
            terzi, hosting provider, societ&agrave; informatiche, agenzie di
            comunicazione) nominati anche, se necessario, Responsabili del
            Trattamento da parte del Titolare. L&#39;elenco aggiornato dei
            Responsabili potr&agrave; sempre essere richiesto al Titolare del
            Trattamento.
            <br />
            <br />
            <h5>Base giuridica del trattamento</h5>
            Il Titolare tratta Dati Personali relativi all&#39;Utente in caso
            sussista una delle seguenti condizioni:
            <br />
            <ul>
                <li>
                    l&#39;Utente ha prestato il consenso per una o pi&ugrave;
                    finalit&agrave; specifiche; Nota: in alcuni ordinamenti il
                    Titolare pu&ograve; essere autorizzato a trattare Dati
                    Personali senza che debba sussistere il consenso
                    dell&#39;Utente o un&#39;altra delle basi giuridiche
                    specificate di seguito, fino a quando l&#39;Utente non si
                    opponga (&quot;opt-out&quot;) a tale trattamento. Ci&ograve;
                    non &egrave; tuttavia applicabile qualora il trattamento di
                    Dati Personali sia regolato dalla legislazione europea in
                    materia di protezione dei Dati Personali;
                </li>
                <li>
                    il trattamento &egrave; necessario all&#39;esecuzione di un
                    contratto con l&#39;Utente e/o all&#39;esecuzione di misure
                    precontrattuali;
                </li>
                <li>
                    il trattamento &egrave; necessario per adempiere un obbligo
                    legale al quale &egrave; soggetto il Titolare;
                </li>
                <li>
                    il trattamento &egrave; necessario per l&#39;esecuzione di
                    un compito di interesse pubblico o per l&#39;esercizio di
                    pubblici poteri di cui &egrave; investito il Titolare;
                </li>
                <li>
                    il trattamento &egrave; necessario per il perseguimento del
                    legittimo interesse del Titolare o di terzi.
                </li>
            </ul>
            &Egrave; comunque sempre possibile richiedere al Titolare di
            chiarire la concreta base giuridica di ciascun trattamento ed in
            particolare di specificare se il trattamento sia basato sulla legge,
            previsto da un contratto o necessario per concludere un contratto.
            <br />
            <br />
            <h5>Luogo</h5>
            I Dati sono trattati presso le sedi operative del Titolare ed in
            ogni altro luogo in cui le parti coinvolte nel trattamento siano
            localizzate. Per ulteriori informazioni, contatta il Titolare.
            <br />
            I Dati Personali dell&#39;Utente potrebbero essere trasferiti in un
            paese diverso da quello in cui l&#39;Utente si trova. Per ottenere
            ulteriori informazioni sul luogo del trattamento l&#39;Utente
            pu&ograve; fare riferimento alla sezione relativa ai dettagli sul
            trattamento dei Dati Personali.
            <br />
            L&#39;Utente ha diritto a ottenere informazioni in merito alla base
            giuridica del trasferimento di Dati al di fuori dell&#39;Unione
            Europea o ad un&#39;organizzazione internazionale di diritto
            internazionale pubblico o costituita da due o pi&ugrave; paesi, come
            ad esempio l&#39;ONU, nonch&eacute; in merito alle misure di
            sicurezza adottate dal Titolare per proteggere i Dati.
            <br />
            L&#39;Utente pu&ograve; verificare se abbia luogo uno dei
            trasferimenti appena descritti esaminando la sezione di questo
            documento relativa ai dettagli sul trattamento di Dati Personali o
            chiedere informazioni al Titolare contattandolo agli estremi
            riportati in apertura.
            <br />
            <br />
            <h5>Periodo di conservazione</h5>
            I Dati sono trattati e conservati per il tempo richiesto dalle
            finalit&agrave; per le quali sono stati raccolti.
            <br />
            Pertanto:
            <br />
            <ul>
                <li>
                    I Dati Personali raccolti per scopi collegati
                    all&#39;esecuzione di un contratto tra il Titolare e
                    l&#39;Utente saranno trattenuti sino a quando sia completata
                    l&#39;esecuzione di tale contratto.
                </li>
                <li>
                    I Dati Personali raccolti per finalit&agrave; riconducibili
                    all&#39;interesse legittimo del Titolare saranno trattenuti
                    sino al soddisfacimento di tale interesse. L&#39;Utente
                    pu&ograve; ottenere ulteriori informazioni in merito
                    all&#39;interesse legittimo perseguito dal Titolare nelle
                    relative sezioni di questo documento o contattando il
                    Titolare.
                </li>
            </ul>
            Quando il trattamento &egrave; basato sul consenso dell&#39;Utente,
            il Titolare pu&ograve; conservare i Dati Personali pi&ugrave; a
            lungo sino a quando detto consenso non venga revocato. Inoltre, il
            Titolare potrebbe essere obbligato a conservare i Dati Personali per
            un periodo pi&ugrave; lungo in ottemperanza ad un obbligo di legge o
            per ordine di un&#39;autorit&agrave;.
            <br />
            Al termine del periodo di conservazione i Dati Personali saranno
            cancellati. Pertanto, allo spirare di tale termine il diritto di
            accesso, cancellazione, rettificazione ed il diritto alla
            portabilit&agrave; dei Dati non potranno pi&ugrave; essere
            esercitati.
            <br />
            <br />
            <h3>Finalit&agrave; del Trattamento dei Dati raccolti</h3>
            I Dati dell&#39;Utente sono raccolti per consentire al Titolare di
            fornire il Servizio, adempiere agli obblighi di legge, rispondere a
            richieste o azioni esecutive, tutelare i propri diritti ed interessi
            (o quelli di Utenti o di terze parti), individuare eventuali
            attivit&agrave; dolose o fraudolente, nonch&eacute; per le seguenti
            finalit&agrave;: ottenere il permesso per l&#39;accesso ai Dati
            Personali presenti sul dispositivo dell&#39;Utente, statistica,
            registrazione ed autenticazione, accesso agli account su servizi
            terzi, registrazione ed autenticazione fornite direttamente da
            questa App e pubblicit&agrave;.
            <br />
            Per ottenere informazioni dettagliate sulle finalit&agrave; del
            trattamento e sui Dati Personali trattati per ciascuna
            finalit&agrave;, l&#39;Utente pu&ograve; fare riferimento alla
            sezione &quot;Dettagli sul trattamento dei Dati Personali&quot;.
            <br />
            <br />
            <h3>
                Permesso per l&#39;accesso ai Dati Personali presenti sul
                dispositivo dell&#39;Utente
            </h3>
            A seconda dello specifico dispositivo utilizzato dall&#39;Utente,
            questa App potrebbe richiedere alcuni permessi per accedere ai Dati
            dell&#39;Utente presenti sul dispositivo stesso, secondo quanto
            descritto in seguito.
            <br />
            Tali permessi devono essere forniti dall&#39;Utente prima che
            qualunque informazione possa essere trattata. In seguito al
            rilascio, il permesso pu&ograve; essere revocato dall&#39;Utente in
            qualunque momento. Al fine di revocare i permessi, l&#39;Utente
            pu&ograve; utilizzare le impostazioni di sistema o contattare il
            Proprietario ai recapiti indicati nel presente documento.
            <br />
            La procedura per il controllo dei permessi pu&ograve; variare in
            funzione del dispositivo e del software utilizzati dall&#39;Utente.
            <br />
            Si prega di considerare che la revoca di uno o pi&ugrave; permessi
            pu&ograve; comportare delle conseguenze sul corretto funzionamento
            di questa App.
            <br />
            Nel caso in cui l&#39;Utente conceda i permessi indicati in seguito,
            i relativi Dati Personali potranno essere oggetto di trattamento
            (accesso, modifica o rimozione) da parte di questa App.
            <br />
            <h5>Permesso account social media</h5>
            Utilizzato per accedere agli account social media dell&#39;Utente
            quali, ad esempio, Facebook e Twitter.
            <br />
            <h5>Permesso fotocamera</h5>
            Utilizzato per accedere alla fotocamera e acquisire immagini dal
            dispositivo, cos&igrave; da poter riconoscere automaticamente un
            numero di targa tramite fotocamera senza che questo venga inserito
            manualmente dall&#39;Utente.
            <br />
            <h5>Permesso per la pubblicit&agrave;</h5>
            Utilizzato per raccogliere identificatori univoci dei dispositivi
            per la pubblicit&agrave; (Google Advertiser ID o identificatore
            IDFA, per esempio) per poter fornire annunci mirati e pi&ugrave;
            efficaci.
            <br />
            <br />
            <h3>Dettagli sul trattamento dei Dati Personali</h3>
            I Dati Personali sono raccolti per le seguenti finalit&agrave; ed
            utilizzando i seguenti servizi:
            <br />
            <br />
            <h5>Accesso agli account su servizi terzi</h5>
            Questo tipo di servizi permettono a questa App di prelevare Dati dai
            tuoi account su servizi terzi ed eseguire azioni con essi.
            <br />
            Questi servizi non sono attivati automaticamente, ma richiedono
            l&#39;espressa autorizzazione dell&#39;Utente.
            <br />
            <h6>Accesso all&#39;account Apple</h6>
            Questo servizio permette a questa App di connettersi con l&#39;Apple
            ID dell&#39;Utente, fornito da Apple, Inc.
            <br />
            Dati personali richiesti: Nome e Cognome, Email (facoltativa).
            <br />
            <h6>Accesso all&#39;account Facebook</h6>
            Questo servizio permette a questa App di connettersi con
            l&#39;account Facebook dell&#39;Utente, fornito da Facebook, Inc.
            <br />
            Dati personali richiesti: Nome, Cognome, Email.
            <br />
            Luogo del trattamento: Stati Uniti – Privacy Policy (
            <a
                href='https://www.facebook.com/help/405977429438260'
                target='_blank'
                rel='noreferrer'
            >
                https://www.facebook.com/help/405977429438260
            </a>
            ); Irlanda – Privacy Policy (
            <a
                href='https://www.facebook.com/help/405977429438260'
                target='_blank'
                rel='noreferrer'
            >
                https://www.facebook.com/help/405977429438260
            </a>
            ).
            <br />
            <h6>Accesso all&#39;account Google</h6>
            Questo servizio permette a questa App di connettersi con
            l&#39;account Google dell&#39;Utente, fornito da Google LLC.
            <br />
            Dati personali richiesti: Nome, Cognome, Email.
            <br />
            Luogo del trattamento: Stati Uniti – Privacy Policy (
            <a
                href='https://policies.google.com/privacy'
                target='_blank'
                rel='noreferrer'
            >
                https://policies.google.com/privacy
            </a>
            ); Irlanda – Privacy Policy (
            <a
                href='https://policies.google.com/privacy'
                target='_blank'
                rel='noreferrer'
            >
                https://policies.google.com/privacy
            </a>
            ).
            <br />
            <h6>Accesso all&#39;account Twitter</h6>
            Questo servizio permette a questa App di connettersi con
            l&#39;account Twitter dell&#39;Utente, fornito da Twitter, Inc.
            <br />
            Dati personali richiesti: Nome, Cognome, Email.
            <br />
            Luogo del trattamento: Stati Uniti – Privacy Policy (
            <a
                href='https://dev.twitter.com/terms/api-terms'
                target='_blank'
                rel='noreferrer'
            >
                https://dev.twitter.com/terms/api-terms
            </a>
            ).
            <br />
            <h5>Pubblicit&agrave;</h5>
            Questo tipo di servizi consente di utilizzare i Dati dell&#39;Utente
            per finalit&agrave; di comunicazione commerciale. Queste
            comunicazioni sono mostrate su questa App sotto forma di banner e
            altre forme pubblicitarie, anche in relazione agli interessi
            dell&#39;Utente. <br />
            Ci&ograve; non significa che tutti i Dati Personali vengano
            utilizzati per questa finalit&agrave;. Dati e condizioni di utilizzo
            sono indicati di seguito. <br />
            Alcuni dei servizi di seguito indicati potrebbero utilizzare Cookie
            o altri Identificatori per identificare l&#39;Utente o utilizzare la
            tecnica del behavioral retargeting, ossia visualizzare annunci
            pubblicitari personalizzati in base agli interessi e al
            comportamento dell&#39;Utente, rilevati anche al di fuori di questa
            App. Per avere maggiori informazioni in merito, ti suggeriamo di
            verificare le informative privacy dei rispettivi servizi. <br />
            In aggiunta alle funzionalit&agrave; di opt-out offerte dai servizi
            di seguito riportati, l&#39;Utente pu&ograve; effettuare
            l&#39;opt-out tramite le impostazioni dell&#39;App.
            <br />
            Gli Utenti possono anche scegliere di non partecipare a determinate
            funzionalit&agrave; pubblicitarie attraverso le corrispondenti
            opzioni di configurazione del dispositivo, come le opzioni di
            configurazione pubblicitaria del dispositivo mobile o la
            configurazione pubblicitaria generica.
            <br />
            <h6>AdMob</h6>
            AdMob &egrave; un servizio di advertising fornito da Google LLC
            oppure da Google Ireland Limited, a seconda della posizione in cui
            questa App viene utilizzata.
            <br />
            Per una comprensione dell&#39;utilizzo dei dati da parte di Google,
            si prega di consultare le norme per i partner di Google (
            <a
                href='https://www.google.com/intl/it/policies/privacy/partners/'
                target='_blank'
                rel='noreferrer'
            >
                https://www.google.com/intl/it/policies/privacy/partners/
            </a>
            ).
            <br />
            Dati Personali trattati: Cookie; Dati di utilizzo; identificatori
            univoci di dispositivi per la pubblicit&agrave; (Google Advertiser
            ID o identificatore IDFA, per esempio).
            <br />
            Luogo del trattamento: Stati Uniti – Privacy Policy (
            <a
                href='https://www.google.com/policies/technologies/ads/'
                target='_blank'
                rel='noreferrer'
            >
                https://www.google.com/policies/technologies/ads/
            </a>
            ) – Opt Out (
            <a
                href='https://adssettings.google.com/authenticated'
                target='_blank'
                rel='noreferrer'
            >
                https://adssettings.google.com/authenticated
            </a>
            ); Irlanda – Privacy Policy (
            <a
                href='https://www.google.com/policies/technologies/ads/'
                target='_blank'
                rel='noreferrer'
            >
                https://www.google.com/policies/technologies/ads/
            </a>
            ).
            <br />
            <h5>Registrazione ed autenticazione</h5>
            Con la registrazione o l&#39;autenticazione l&#39;Utente consente a
            questa App di identificarlo e di dargli accesso a servizi dedicati.
            <br />
            A seconda di quanto indicato di seguito, i servizi di registrazione
            e di autenticazione potrebbero essere forniti con l&#39;ausilio di
            terze parti. Qualora questo avvenga, questa App potr&agrave;
            accedere ad alcuni Dati conservati dal servizio terzo usato per la
            registrazione o l&#39;identificazione. <br />
            Alcuni dei servizi di seguito indicati potrebbero raccogliere Dati
            Personali anche per fini di targeting e profilazione; per saperne di
            pi&ugrave;, si prega di fare riferimento alla descrizione di ciascun
            servizio.
            <br />
            <h6>Google OAuth</h6>
            Google OAuth &egrave; un servizio di registrazione ed autenticazione
            fornito da Google LLC oppure da Google Ireland Limited, a seconda
            della posizione in cui questa App viene utilizzata, e collegato al
            network Google.
            <br />
            Dati Personali trattati: varie tipologie di Dati secondo quanto
            specificato dalla privacy policy del servizio.
            <br />
            Luogo del trattamento: Stati Uniti – Privacy Policy (
            <a
                href='https://policies.google.com/privacy'
                target='_blank'
                rel='noreferrer'
            >
                https://policies.google.com/privacy
            </a>
            ); Irlanda – Privacy Policy (
            <a
                href='https://policies.google.com/privacy'
                target='_blank'
                rel='noreferrer'
            >
                https://policies.google.com/privacy
            </a>
            ).
            <br />
            <h6>Twitter OAuth</h6>
            Twitter OAuth &egrave; un servizio di registrazione ed
            autenticazione fornito da Twitter, Inc. e collegato al social
            network Twitter.
            <br />
            Dati Personali trattati: varie tipologie di Dati secondo quanto
            specificato dalla privacy policy del servizio.
            <br />
            Luogo del trattamento: Stati Uniti – Privacy Policy (
            <a
                href='https://dev.twitter.com/terms/api-terms'
                target='_blank'
                rel='noreferrer'
            >
                https://dev.twitter.com/terms/api-terms
            </a>
            ).
            <br />
            <h6>Facebook Authentication</h6>
            Facebook Authentication &egrave; un servizio di registrazione ed
            autenticazione fornito da Facebook, Inc. oppure da Facebook Ireland
            Ltd, a seconda della posizione in cui questa App viene utilizzata, e
            collegato al social network Facebook.
            <br />
            Dati Personali trattati: varie tipologie di Dati secondo quanto
            specificato dalla privacy policy del servizio.
            <br />
            Luogo del trattamento: Stati Uniti – Privacy Policy (
            <a
                href='https://www.facebook.com/help/405977429438260'
                target='_blank'
                rel='noreferrer'
            >
                https://www.facebook.com/help/405977429438260
            </a>
            ); Irlanda – Privacy Policy (
            <a
                href='https://www.facebook.com/help/405977429438260'
                target='_blank'
                rel='noreferrer'
            >
                https://www.facebook.com/help/405977429438260
            </a>
            ).
            <br />
            <h5>
                Registrazione ed autenticazione fornite direttamente da questa
                App
            </h5>
            Con la registrazione o l&#39;autenticazione l&#39;Utente consente a
            questa App di identificarlo e di dargli accesso a servizi dedicati.
            I Dati Personali sono raccolti e conservati esclusivamente a scopo
            di registrazione o di identificazione. I Dati raccolti sono solo
            quelli necessari a fornire il servizio richiesto dall&#39;Utente.
            <br />
            <h6>Registrazione diretta</h6>
            L&#39;Utente si registra compilando il modulo di registrazione e
            fornendo direttamente a questa App i propri Dati Personali.
            <br />
            Dati Personali trattati: nome, cognome, email, password.
            <br />
            <h5>Richieste di supporto inoltrate direttamente da questa App</h5>
            Con l&#39;invio di richieste di supporto l&#39;Utente consente a
            questa App di identificarlo e di dargli accesso ad una chat di
            supporto dedicata. I Dati Personali sono raccolti e conservati
            esclusivamente a scopo di supporto o di identificazione. I Dati
            raccolti sono solo quelli necessari a fornire il servizio richiesto
            dall&#39;Utente.
            <br />
            <h6>Richiesta di supporto diretta</h6>
            L&#39;Utente invia una richiesta di supporto compilando il modulo
            relativo e fornendo direttamente a questa App i propri Dati
            Personali.
            <br />
            Dati Personali trattati: nome, cognome, email.
            <br />
            <h5>Statistica</h5>
            I servizi contenuti nella presente sezione permettono al Titolare
            del Trattamento di monitorare e analizzare i dati di traffico e
            servono a tener traccia del comportamento dell&#39;Utente.
            <br />
            <h6>Google Analytics</h6>
            Google Analytics &egrave; un servizio di analisi web fornito da
            Google LLC oppure da Google Ireland Limited, a seconda della
            posizione in cui questa App viene utilizzata, (&quot;Google&quot;).
            Google utilizza i Dati Personali raccolti allo scopo di tracciare ed
            esaminare l&#39;utilizzo di questa App, compilare report e
            condividerli con gli altri servizi sviluppati da Google.
            <br />
            Google potrebbe utilizzare i Dati Personali per contestualizzare e
            personalizzare gli annunci del proprio network pubblicitario.
            <br />
            Dati Personali trattati: Cookie; Dati di utilizzo.
            <br />
            Luogo del trattamento: Stati Uniti – Privacy Policy (
            <a
                href='https://policies.google.com/privacy'
                target='_blank'
                rel='noreferrer'
            >
                https://policies.google.com/privacy
            </a>
            ) – Opt Out (
            <a
                href='https://tools.google.com/dlpage/gaoptout?hl=it'
                target='_blank'
                rel='noreferrer'
            >
                https://tools.google.com/dlpage/gaoptout?hl=it
            </a>
            ); Irlanda – Privacy Policy (
            <a
                href='https://policies.google.com/privacy'
                target='_blank'
                rel='noreferrer'
            >
                https://policies.google.com/privacy
            </a>
            ) – Opt Out (
            <a
                href='https://tools.google.com/dlpage/gaoptout?hl=it'
                target='_blank'
                rel='noreferrer'
            >
                https://tools.google.com/dlpage/gaoptout?hl=it
            </a>
            ).
            <br />
            <br />
            <h3>Diritti dell&#39;Utente</h3>
            Gli Utenti possono esercitare determinati diritti con riferimento ai
            Dati trattati dal Titolare.
            <br />
            In particolare, l&#39;Utente ha il diritto di:
            <br />
            <ul>
                <li>
                    <b>revocare il consenso in ogni momento.</b> L&#39;Utente
                    pu&ograve; revocare il consenso al trattamento dei propri
                    Dati Personali precedentemente espresso.
                </li>
                <li>
                    <b>opporsi al trattamento dei propri Dati.</b> L&#39;Utente
                    pu&ograve; opporsi al trattamento dei propri Dati quando
                    esso avviene su una base giuridica diversa dal consenso.
                    Ulteriori dettagli sul diritto di opposizione sono indicati
                    nella sezione sottostante.
                </li>
                <li>
                    <b>accedere ai propri Dati.</b> L&#39;Utente ha diritto ad
                    ottenere informazioni sui Dati trattati dal Titolare, su
                    determinati aspetti del trattamento ed a ricevere una copia
                    dei Dati trattati.
                </li>
                <li>
                    <b>verificare e chiedere la rettificazione.</b> L&#39;Utente
                    pu&ograve; verificare la correttezza dei propri Dati e
                    richiederne l&#39;aggiornamento o la correzione.
                </li>
                <li>
                    <b>ottenere la limitazione del trattamento.</b> Quando
                    ricorrono determinate condizioni, l&#39;Utente pu&ograve;
                    richiedere la limitazione del trattamento dei propri Dati.
                    In tal caso il Titolare non tratter&agrave; i Dati per alcun
                    altro scopo se non la loro conservazione.
                </li>
                <li>
                    <b>
                        ottenere la cancellazione o rimozione dei propri Dati
                        Personali.
                    </b>{' '}
                    Quando ricorrono determinate condizioni, l&#39;Utente
                    pu&ograve; richiedere la cancellazione dei propri Dati da
                    parte del Titolare.
                </li>
                <li>
                    <b>
                        ricevere i propri Dati o farli trasferire ad altro
                        titolare.
                    </b>{' '}
                    L&#39;Utente ha diritto di ricevere i propri Dati in formato
                    strutturato, di uso comune e leggibile da dispositivo
                    automatico e, ove tecnicamente fattibile, di ottenerne il
                    trasferimento senza ostacoli ad un altro titolare. Questa
                    disposizione &egrave; applicabile quando i Dati sono
                    trattati con strumenti automatizzati ed il trattamento
                    &egrave; basato sul consenso dell&#39;Utente, su un
                    contratto di cui l&#39;Utente &egrave; parte o su misure
                    contrattuali ad esso connesse.
                </li>
                <li>
                    <b>proporre reclamo.</b> L&#39;Utente pu&ograve; proporre un
                    reclamo all&#39;autorit&agrave; di controllo della
                    protezione dei dati personali competente o agire in sede
                    giudiziale.
                </li>
            </ul>
            <br />
            <h5>Dettagli sul diritto di opposizione</h5>
            Quando i Dati Personali sono trattati nell&#39;interesse pubblico,
            nell&#39;esercizio di pubblici poteri di cui &egrave; investito il
            Titolare oppure per perseguire un interesse legittimo del Titolare,
            gli Utenti hanno diritto ad opporsi al trattamento per motivi
            connessi alla loro situazione particolare.
            <br />
            Si fa presente agli Utenti che, ove i loro Dati fossero trattati con
            finalit&agrave; di marketing diretto, possono opporsi al trattamento
            senza fornire alcuna motivazione. Per scoprire se il Titolare tratti
            dati con finalit&agrave; di marketing diretto gli Utenti possono
            fare riferimento alle rispettive sezioni di questo documento.
            <br />
            <br />
            <h5>Come esercitare i diritti</h5>
            Per esercitare i diritti dell&#39;Utente, gli Utenti possono
            indirizzare una richiesta agli estremi di contatto del Titolare
            indicati in questo documento. Le richieste sono depositate a titolo
            gratuito e evase dal Titolare nel pi&ugrave; breve tempo possibile.
            <br />
            <br />
            <h3>Ulteriori informazioni sul trattamento</h3>
            <h5>Difesa in giudizio</h5>
            I Dati Personali dell&#39;Utente possono essere utilizzati da parte
            del Titolare in giudizio o nelle fasi preparatorie alla sua
            eventuale instaurazione per la difesa da abusi nell&#39;utilizzo di
            questa App o dei Servizi connessi da parte dell&#39;Utente.
            <br />
            L&#39;Utente dichiara di essere consapevole che il Titolare potrebbe
            essere obbligato a rivelare i Dati per ordine delle autorit&agrave;
            pubbliche.
            <br />
            <br />
            <h5>Informative specifiche</h5>
            Su richiesta dell&#39;Utente, in aggiunta alle informazioni
            contenute in questa privacy policy, questa App potrebbe fornire
            all&#39;Utente delle informative aggiuntive e contestuali
            riguardanti Servizi specifici, o la raccolta ed il trattamento di
            Dati Personali.
            <br />
            <br />
            <h5>Log di sistema e manutenzione</h5>
            Per necessit&agrave; legate al funzionamento ed alla manutenzione,
            questa App e gli eventuali servizi terzi da essa utilizzati
            potrebbero raccogliere log di sistema, ossia file che registrano le
            interazioni e che possono contenere anche Dati Personali, quali
            l&#39;indirizzo IP Utente.
            <br />
            <br />
            <h5>Informazioni non contenute in questa policy</h5>
            Ulteriori informazioni in relazione al trattamento dei Dati
            Personali potranno essere richieste in qualsiasi momento al Titolare
            del Trattamento utilizzando gli estremi di contatto.
            <br />
            <br />
            <h5>Modifiche a questa privacy policy</h5>
            Il Titolare del Trattamento si riserva il diritto di apportare
            modifiche alla presente privacy policy in qualunque momento
            notificandolo agli Utenti su questa pagina e, se possibile, su
            questa App nonch&eacute;, qualora tecnicamente e legalmente
            fattibile, inviando una notifica agli Utenti attraverso uno degli
            estremi di contatto di cui &egrave; in possesso. Si prega dunque di
            consultare con frequenza questa pagina, facendo riferimento alla
            data di ultima modifica indicata in fondo.
            <br />
            <br />
            Qualora le modifiche interessino trattamenti la cui base giuridica
            &egrave; il consenso, il Titolare provveder&agrave; a raccogliere
            nuovamente il consenso dell&#39;Utente, se necessario.
            <br />
            <br />
            <h3>Definizioni e riferimenti legali</h3>
            <h5>Dati Personali (o Dati)</h5>
            Costituisce dato personale qualunque informazione che, direttamente
            o indirettamente, anche in collegamento con qualsiasi altra
            informazione, ivi compreso un numero di identificazione personale,
            renda identificata o identificabile una persona fisica.
            <br />
            <br />
            <h5>Dati di Utilizzo</h5>
            Sono le informazioni raccolte automaticamente attraverso questa App
            (anche da app di parti terze integrate in questa App), tra cui: gli
            indirizzi IP o i nomi a dominio dei dispositivi utilizzati
            dall&#39;Utente che si connette con questa App, gli indirizzi in
            notazione URI (Uniform Resource Identifier), l&#39;orario della
            richiesta, il metodo utilizzato nell&#39;inoltrare la richiesta al
            server, la dimensione del file ottenuto in risposta, il codice
            numerico indicante lo stato della risposta dal server (buon fine,
            errore, ecc.) il paese di provenienza, le caratteristiche del
            browser e del sistema operativo utilizzati dal visitatore, le varie
            connotazioni temporali della visita (ad esempio il tempo di
            permanenza su ciascuna pagina) e i dettagli relativi
            all&#39;itinerario seguito all&#39;interno dell&#39;App, con
            particolare riferimento alla sequenza delle pagine consultate, ai
            parametri relativi al sistema operativo e all&#39;ambiente
            informatico dell&#39;Utente.
            <br />
            <br />
            <h5>Utente</h5>
            L&#39;individuo che utilizza questa App che, salvo ove diversamente
            specificato, coincide con l&#39;Interessato.
            <br />
            <br />
            <h5>Interessato</h5>
            La persona fisica cui si riferiscono i Dati Personali.
            <br />
            <br />
            <h5>Responsabile del Trattamento (o Responsabile)</h5>
            La persona fisica, giuridica, la pubblica amministrazione e
            qualsiasi altro ente che tratta dati personali per conto del
            Titolare, secondo quanto esposto nella presente privacy policy.
            <br />
            <br />
            <h5>Titolare del Trattamento (o Titolare)</h5>
            La persona fisica o giuridica, l&#39;autorit&agrave; pubblica, il
            servizio o altro organismo che, singolarmente o insieme ad altri,
            determina le finalit&agrave; e i mezzi del trattamento di dati
            personali e gli strumenti adottati, ivi comprese le misure di
            sicurezza relative al funzionamento ed alla fruizione di questa App.
            Il Titolare del Trattamento, salvo quanto diversamente specificato,
            &egrave; il titolare di questa App.
            <br />
            <br />
            <h5>Questa App</h5>
            Lo strumento software mediante il quale sono raccolti e trattati i
            Dati Personali degli Utenti.
            <br />
            <br />
            <h5>Servizio</h5>
            Il Servizio fornito da questa App cos&igrave; come definito nei
            relativi termini su questo sito/app.
            <br />
            <br />
            <h5>Unione Europea (o UE)</h5>
            Salvo ove diversamente specificato, ogni riferimento all&#39;Unione
            Europea contenuto in questo documento si intende esteso a tutti gli
            attuali stati membri dell&#39;Unione Europea e dello Spazio
            Economico Europeo.
            <br />
            <br />
            <h5>Cookie</h5>
            I Cookie sono Strumenti di Tracciamento che consistono in piccole
            porzioni di dati conservate all&#39;interno del browser
            dell&#39;Utente.
            <br />
            <br />
            <h5>Strumento di Tracciamento</h5>
            Per Strumento di Tracciamento s&#39;intende qualsiasi tecnologia -
            es. Cookie, identificativi univoci, web beacons, script integrati,
            e-tag e fingerprinting - che consenta di tracciare gli Utenti, per
            esempio raccogliendo o salvando informazioni sul dispositivo
            dell&#39;Utente.
            <br />
            <br />
            <h5>Riferimenti legali</h5>
            La presente informativa privacy &egrave; redatta sulla base di
            molteplici ordinamenti legislativi, inclusi gli artt. 13 e 14 del
            Regolamento (UE) 2016/679.
            <br />
            Ove non diversamente specificato, questa informativa privacy
            riguarda esclusivamente questa App.
            <br />
            <br />
            Documento aggiornamento al 22 marzo 2021.
            <br />
        </Content>
    </>
)
export default Page

const Heading = styled.h1`
    margin: 0 0 15px;
`

const Content = styled.div`
    font-size: 15px;
    line-height: 1.3;
    & h3 {
        font-size: 19px;
        font-weight: bold;
        margin: 20px 0 5px;
    }
    & h5 {
        font-size: 17px;
        font-weight: bold;
        margin: 0;
        padding: 0;
    }
    & h6 {
        font-size: 16px;
        font-weight: bold;
        margin: 5px 0 0px;
        padding: 0;
    }
`
